export function addBreakpoint(element, breakpointFunc, breakpointClassName = 'desktop', sessionStorageKey = 'breakpoint') {
  let timeout = null;
  // Create a new ResizeObserver
  const BreakpointObserver = new ResizeObserver(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      // Test if the element is breaking
      let IS_BREAKING = false;
      if (breakpointFunc && typeof breakpointFunc === 'function') {
        IS_BREAKING = breakpointFunc();
      }
      window.requestAnimationFrame(() => {
        if (!IS_BREAKING) {
          // Set the sessionStorage item to the class
          sessionStorage.setItem(sessionStorageKey, breakpointClassName);
          // Add the class to the element
          element.classList.add(breakpointClassName);
        } else {
          // Remove the sessionStorage item
          sessionStorage.removeItem(sessionStorageKey);
          // Remove the class from the element
          element.classList.remove(breakpointClassName);
        }
      });
    }, 100);
  });
  BreakpointObserver.observe(element);
}